import React from 'react';

import {
  MainBox,
  IngredientCircle,
  IngredientName,
} from './IngredientIcon.style';

type IngredientIconProps = {
  title: string;
  isActive: boolean;
  clickHandler: () => void;
  backgroundColor: string;
  iconImage: JSX.Element | string;
  titleColor?: string;
};

export const IngredientIcon = ({
  isActive,
  title,
  clickHandler,
  backgroundColor,
  iconImage,
  titleColor,
}: IngredientIconProps) => (
  <MainBox onClick={clickHandler}>
    <IngredientCircle backgroundColor={backgroundColor} titleColor={titleColor}>
      {iconImage}
    </IngredientCircle>
    <IngredientName isActive={isActive} titleColor={titleColor}>
      {title}
    </IngredientName>
  </MainBox>
);
